import React, { useState } from "react";
import ContinueButton from "../../Registration/ContinueButton";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetPassword } from "../../store/authSlice";

const EnterEmail = ({ setNextPageTriggered }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) return;

    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
    } else {
      setError("");
      dispatch(resetPassword({ email }))
      .unwrap()
      .then((response) => {
        setNextPageTriggered(true);
      })
      .catch((error) => {
        alert(error || "Failed to send reset email.");
      });
    
    }
  };

  

  return (
    <section className="flex flex-col items-center min-h-screen justify-center bg-white py-10 px-6">
      <header className="text-center mb-14">
        <h1 className="text-2xl font-semibold text-[#1d2639]">
          Forgot Password
        </h1>
        <p className="text-base font-medium text-[#7e7e7e] w-full sm:w-[394px]">
          Enter your email to reset your password.
        </p>
      </header>

      <form
        className="flex flex-col justify-center w-full sm:w-[572px]"
        onSubmit={handleSubmit}
        aria-labelledby="form-title"
      >
        <h1 id="form-title" className="sr-only">
          User Email
        </h1>

        <fieldset
          className="w-full h-auto flex flex-col justify-center items-start gap-2 mb-10"
          aria-labelledby="email-label"
          aria-describedby="email-error"
        >
          <legend className="sr-only">User Email</legend>

          <label
            htmlFor="email"
            id="email-label"
            className="text-[#1d2639] text-base font-normal font-['Lato']"
          >
            Email
          </label>

          <input
            type="text"
            id="email"
            name="email"
            placeholder="Enter your Email"
            className={`w-full h-12 p-3 bg-[#f9f9f9] rounded-lg border-2 ${
              error ? "border-red-500" : "border-gray-300"
            }`}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (error) setError("");
            }}
            aria-describedby="email-error"
          />
          {error && (
            <span id="email-error" className="text-red-500 text-sm">
              {error}
            </span>
          )}
        </fieldset>

        <ContinueButton
          isDisabled={!email}
          onClick={handleSubmit}
          label="Reset Password"
        />
        <button
          className="text-[#7E7E7E] mt-4"
          onClick={() => navigate("/login")}
        >
          Cancel
        </button>
      </form>
    </section>
  );
};

export default EnterEmail;
